module.exports = __webpack_public_path__ + "static/media/sun.c1235bdc.svg";